var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert(".h-100 {\n  height: 100%;\n}\n\n.d-flex {\n  display: flex;\n}\n\n.flex-column {\n  flex-direction: column;\n}\n\n.helper-text {\n  font-size: 0.875rem;\n  font-weight: 400;\n  opacity: 0.75;\n  padding: 10px;\n}")
;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ["account_balances", "can_view_account", "selected_merchant", "label"],
  data: function data() {
    return {
      loading: false
    };
  },
  mounted: function mounted() {},

  methods: {
    to_human: function to_human(x) {
      if (x == null) return 0;
      var n = this.to_fixed(x);
      return this.formatNumber(n.toLocaleString());
    },
    formatNumber: function formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    to_fixed: function to_fixed(val) {
      return (Math.round(val * 100) / 100).toFixed(2);
    },
    to_human_no_fixed: function to_human_no_fixed(x) {
      if (x == null) return 0;
      return x.toLocaleString();
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100"},[_c('div',{staticClass:"card mb-0 h-100"},[_c('div',{staticClass:"card-body text-left pb-0 d-flex flex-column h-100"},[(_vm.label == 'Today ')?_c('h4',[_vm._v("Current Wallet Balance")]):_c('h4',[_vm._v("Wallet Credits")]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('p',{staticClass:"mb-1 lead"}),_vm._v(" "),_vm._l((_vm.account_balances),function(account_balance){return (_vm.selected_merchant)?_c('p',{key:account_balance.balance,staticClass:"mb-1 lead"},[(!_vm.loading)?_c('span',{class:account_balance.is_default_currency
              ? 'btn btn-sm btn-light'
              : 'btn btn-sm btn-danger'},[_c('b',[_vm._v(_vm._s(account_balance.currency)+"\n            "+_vm._s(_vm.to_human(account_balance.balance)))])]):_vm._e()]):_vm._e()}),_vm._v(" "),_c('p',{staticClass:"mb-1 lead"},[(_vm.loading)?_c('span',{staticClass:"btn btn-sm btn-danger"},[_c('b',[_vm._v("loading...")])]):_vm._e()]),_vm._v(" "),(!_vm.selected_merchant)?_c('p',{staticClass:"mb-1 muted helper-text"},[_vm._v("\n        Please select a merchant to view the balance\n      ")]):_vm._e(),_vm._v(" "),(_vm.selected_merchant && _vm.label != 'Today ')?_c('p',{staticClass:"mb-3 muted helper-text"},[_vm._v("\n        As of an hour ago\n      ")]):_vm._e()],2)])])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  module.hot.dispose(__vueify_style_dispose__)
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-dda71720", __vue__options__)
  } else {
    hotAPI.reload("data-v-dda71720", __vue__options__)
  }
})()}